import { apiGetAuth, apiPostAuth, apiPutAuth } from '@/utils/api'
import { API_KEYWORD_RESTRICTION } from '@/utils/api-url'

import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    keyword_restriction: { data: [] },
    validate_bulk_result: {},
    data_modal_add_edit: {},
    meta_filter: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,  
      title: '', 
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_KEYWORD_RESTRICTION (state, payload) {
    state.keyword_restriction = payload
  },
  SET_VALIDATE_BULK_RESULT (state, payload) {
    state.validate_bulk_result = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListKeywordRestriction (context, payload) {
    try {
      const response = await apiGetAuth(API_KEYWORD_RESTRICTION.LIST_KEYWORD_RESTRICTION, payload)
      
      const fallbackData = response?.data || { data: [] }
      context.commit('SET_KEYWORD_RESTRICTION', fallbackData)
    } catch (error) {
      console.log(error)
      notificationDanger(error?.message || error)
    }
  },

  async createKeywordRestriction (context, payload) {
    try {
      const response = await apiPostAuth(API_KEYWORD_RESTRICTION.CREATE_KEYWORD_RESTRICTION, payload)
      return response?.data || null
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })

      console.error('[Store Action Error: createKeywordRestriction] Network/API failure:', { payload, error })

      const enrichedError = Object.assign(error, {
        storeAction: 'createKeywordRestriction',
        dispatchedPayload: payload
      })

      return Promise.reject(enrichedError) 
    }
  },

  async updateKeywordRestriction (context, payload) {
    if (!payload?.id) {
      const validationError = new Error('Failed to update keyword restriction: Missing required payload ID.')
      console.error(validationError.message, payload)
      notificationDanger('Unable to update data. Invalid keyword reference ID.')
      return null
    }

    try {
      const response = await apiPutAuth(API_KEYWORD_RESTRICTION.UPDATE_KEYWORD_RESTRICTION(payload.id), payload.reqBody)
      return response?.data || null
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })

      console.error('[Store Action Error: updateKeywordRestriction] Network/API failure:', { id: payload.id, reqBody: payload.reqBody, error })

      const enrichedError = Object.assign(error, {
        storeAction: 'updateKeywordRestriction',
        targetId: payload.id,
        dispatchedPayload: payload.reqBody
      })

      return Promise.reject(enrichedError) 
    }
  },

  async validateBulkKeyword (context, payload) {
    try {
      const response = await apiPostAuth(API_KEYWORD_RESTRICTION.VALIDATE_BULK_KEYWORD_RESTRICTION, payload)
      const safeDataResult = response?.data?.data || {}
      context.commit('SET_VALIDATE_BULK_RESULT', safeDataResult)
      return response?.data || null
    } catch (error) {
      notificationDanger(error?.message || error)
    }
  },

  async uploadBulkKeyword (context, payload) {
    try {
      const response = await apiPostAuth(API_KEYWORD_RESTRICTION.UPLOAD_BULK_KEYWORD_RESTRICTION, payload)
      return response?.data || null
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error?.message || error)
    }
  }
}

const getters = {
  list_keyword_restriction (state) {
    return state.keyword_restriction
  },
  validate_bulk_result (state) {
    return state.validate_bulk_result
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
